import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Input,
    FormControl,
    FormLabel,
    FormErrorMessage
} from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

const EditCategoryModal = ({ isOpen, onClose, category, onSave }) => {
    const { t } = useTranslation("default");
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (category) {
            setName(category.name || '');
        }
    }, [category]);

    const handleSave = async () => {
        if (!name.trim()) {
            setError(t('category.error.empty_name'));
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            await onSave(category.id, name.trim());
            onClose();
        } catch (err) {
            setError(t('category.error.save'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setName('');
        setError('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{t('category.edit.modal_title')}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl isInvalid={!!error}>
                        <FormLabel>{t('category.form.name')}</FormLabel>
                        <Input
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                setError('');
                            }}
                            placeholder={t('category.form.placeholder.name')}
                            borderRadius={'12px'}
                        />
                        {error && <FormErrorMessage>{error}</FormErrorMessage>}
                    </FormControl>
                </ModalBody>

                <ModalFooter gap="8px">
                    <Button
                        variant="ghost"
                        onClick={handleClose}
                        borderRadius={'12px'}
                    >
                        {t('action.cancel')}
                    </Button>
                    <Button
                        bg="brand.500"
                        color="white"
                        onClick={handleSave}
                        isLoading={isLoading}
                        borderRadius={'12px'}
                        _hover={{ bg: 'brand.600' }}
                    >
                        {t('action.save')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditCategoryModal;
